var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookF = function SvgFacebookF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4673828,87.5 L39.4673828,52.1660156 L27.6328125,52.1660156 L27.6328125,38.125 L39.4673828,38.125 L39.4673828,27.0619141 C39.4673828,15.0421875 46.8119141,8.5 57.5355469,8.5 C62.6736328,8.5 67.0865234,8.88574219 68.3671875,9.05546875 L68.3671875,21.6152344 L60.9300781,21.6152344 C55.0976562,21.6152344 53.9712891,24.3925781 53.9712891,28.4505859 L53.9712891,38.125 L67.1328125,38.125 L65.3275391,52.1660156 L53.9712891,52.1660156 L53.9712891,87.5",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgFacebookF;